import { axisTop } from 'd3-axis';
import { scaleLinear } from 'd3-scale';

const TICKS = [0, 33, 66, 100];

/**
 * Render the cloud-cover percentage axis at the top of the chart.
 *
 * Matches Skysight's `cloud-axis` group: a narrow strip spanning only
 * 10°C of x-axis width (from x(tMin) to x(tMin+10)) — NOT the full chart.
 *
 * Source: docs/skysight-skewt-bundle.js
 *   l = tt().range([this.x(this.tMin), this.x(this.tMin + 10)]).domain([0, 100])
 *
 * @param {import('d3-selection').Selection} container
 * @param {import('../skewt/scales.js').Scales} scales
 * @param {Array} data - unused for axis but kept for signature symmetry
 */
export function drawCloudCoverAxis(container, scales, data, i18n = {}) {
    const cloudCoverLabel = i18n.cloudCover || 'Cloud Cover';
    container.selectAll('.skewt-ext-cloud-axis').remove();

    // Skysight: bar spans 10°C of temperature width, anchored at tMin.
    const xMin = scales.x(scales.tMin);
    const xMax = scales.x(scales.tMin + 10);
    const cloudScale = scaleLinear().domain([0, 100]).range([xMin, xMax]);
    const axis = axisTop(cloudScale).tickValues(TICKS).tickSize(5).tickFormat(d => `${d}%`);

    const g = container.append('g')
        .attr('class', 'skewt-ext-cloud-axis')
        .attr('transform', 'translate(0, -5)');

    g.call(axis);
    g.selectAll('text').style('font-size', '10px').style('fill', 'rgb(102, 102, 102)');

    // Color strip below ticks (Skysight uses a transparent→gray gradient)
    const defs = container.select('defs').empty()
        ? container.append('defs')
        : container.select('defs');
    const gradId = 'skewt-ext-cloud-gradient';
    defs.select(`#${gradId}`).remove();
    const grad = defs.append('linearGradient').attr('id', gradId)
        .attr('x1', '0%').attr('y1', '0%').attr('x2', '100%').attr('y2', '0%');
    grad.append('stop').attr('offset', '0%').attr('stop-color', 'rgba(60,60,60,0)');
    grad.append('stop').attr('offset', '100%').attr('stop-color', 'rgba(60,60,60,0.6)');

    g.append('rect')
        .attr('x', xMin)
        .attr('y', 3)        // just below the axis ticks
        .attr('width', xMax - xMin)
        .attr('height', 4)
        .attr('fill', `url(#${gradId})`);

    // "Cloud Cover" label centered over the narrow bar.
    // Skysight style: font-size 11px, font-weight 500, fill rgb(102,102,102).
    g.append('text')
        .attr('class', 'cloud-label')
        .attr('x', (xMin + xMax) / 2)
        .attr('y', -22)
        .attr('text-anchor', 'middle')
        .style('font-size', '11px')
        .style('font-weight', '500')
        .style('fill', 'rgb(102, 102, 102)')
        .text(cloudCoverLabel);
}
